export interface ContactFilterType {
  selectedContacts: server.dto.ContactSmallV2[]
}

export const getSortedContacts = (filter: ContactFilterType) => {
  return filter.selectedContacts.map(a => a.name.fullName)
    .sort((a, b) => a.localeCompare(b));
};

export const initialContactFilter: ContactFilterType = {
  selectedContacts: []
};
